/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function BookOpen(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 16 16" fill="none" height={size} width={size} {...other}>
      <path
        d="M8.8 14.4V16H7.2V14.4H0.8C0.587827 14.4 0.384344 14.3157 0.234315 14.1657C0.0842854 14.0157 0 13.8122 0 13.6V0.800002C0 0.587829 0.0842854 0.384346 0.234315 0.234317C0.384344 0.0842877 0.587827 2.24691e-06 0.8 2.24691e-06H5.6C6.05407 -0.000536483 6.50303 0.0958072 6.91689 0.2826C7.33076 0.469393 7.70002 0.742335 8 1.0832C8.29998 0.742335 8.66923 0.469393 9.0831 0.2826C9.49697 0.0958072 9.94593 -0.000536483 10.4 2.24691e-06H15.2C15.4122 2.24691e-06 15.6157 0.0842877 15.7657 0.234317C15.9157 0.384346 16 0.587829 16 0.800002V13.6C16 13.8122 15.9157 14.0157 15.7657 14.1657C15.6157 14.3157 15.4122 14.4 15.2 14.4H8.8ZM14.4 12.8V1.6H10.4C9.97565 1.6 9.56869 1.76857 9.26863 2.06863C8.96857 2.36869 8.8 2.77566 8.8 3.2V12.8H14.4ZM7.2 12.8V3.2C7.2 2.77566 7.03143 2.36869 6.73137 2.06863C6.43131 1.76857 6.02435 1.6 5.6 1.6H1.6V12.8H7.2Z"
        fill={color}
      />
    </svg>
  );
}

BookOpen.defaultProps = {
  color: "currentColor",
  size: 24,
};

BookOpen.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
